import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  RECAPTCHA_LANGUAGE,
  RECAPTCHA_SETTINGS,
  RecaptchaLoaderService,
} from 'ng-recaptcha';
import { BehaviorSubject, Observable } from 'rxjs';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LocalStorageKeys } from './modules/shared/enums';
import { TokenInterceptorService } from './modules/shared/services/token-interceptor-service/token-interceptor.service';
import { WebpayModalModule } from './modules/webpay-modal/webpay-modal.module';

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@Injectable()
export class PreloadedRecaptchaAPIService {
  public ready: Observable<ReCaptchaV2.ReCaptcha>;

  constructor() {
    const readySubject = new BehaviorSubject<ReCaptchaV2.ReCaptcha>(null);
    this.ready = readySubject.asObservable();

    const interval = setInterval(() => {
      if (
        typeof grecaptcha === 'undefined' ||
        !(grecaptcha.render instanceof Function)
      ) {
        return;
      }

      clearInterval(interval);
      readySubject.next(grecaptcha);
    }, 50);
  }
}

export const recaptchaService = new PreloadedRecaptchaAPIService();

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    WebpayModalModule,
    MatSnackBarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    {
      provide: RecaptchaLoaderService,
      useValue: recaptchaService,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: '6Lch96sZAAAAAJ9IrCM2ZOjzqM1sYSQfkI-lvy1C',
      },
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: localStorage.getItem(LocalStorageKeys.LANGUAGE),
    },
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
